import React from "react";
import { colors } from "utils/styles";

//Not for use with contentful data
export default function Text(props) {
	const classes = props.className ? props.className : " ";

	//adding px is optional, sometimes it's there, sometimes it not.
	let size = props.size;
	if (size && typeof size === "string") {
		size = size = size.replace("px", "");
	}
	let marginBottom = props.marginBottom?.toString();
	if (marginBottom) {
		marginBottom = marginBottom = marginBottom.replace("px", "");
	}
	const display = props.display || "inline-block";
	return (
		<span className={`${classes} d-${display}`}>
			<p className={`d-${display}`}>{props.text}</p>
			<style jsx>{`
				p {
					font-style: ${props.fontStyle || "inherit"};
					font-weight: ${props.weight || "normal"};
					text-decoration: ${props.decoration || "none"};
					font-size: ${size !== undefined ? size : "28"}px;
					color: ${props.color ? props.color : "inherit"};
					margin-bottom: ${marginBottom !== undefined ? marginBottom : "16"}px;
					text-align: ${props.align ? props.align : "inherit"};
					line-height: ${props.lineHeight ? props.lineHeight : "inherit"};
					letter-spacing: ${props.letterSpace ? props.letterSpace : "normal"};
				}
			`}</style>
		</span>
	);
}
